import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import { Box } from '@qwealth/qcore';

import { KypFilters } from 'data/models/Kyp';
import { getKyps } from 'data/actions/KYP';
import { initialKypFilters } from 'data/refData/kyp';
import KypFilterForm from './KypFiltersForm';

const KypFilterSection: FC = (): JSX.Element => {
  const dispatch = useDispatch();

  const handleSubmit = (values: any) => {
    dispatch(getKyps(values));
  };

  return (
    <Box width="100%" marginBottom="default">
      <Form<KypFilters>
        onSubmit={handleSubmit}
        initialValues={initialKypFilters}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <KypFilterForm />
          </form>
        )}
      ></Form>
    </Box>
  );
};

export default KypFilterSection;
